import { render, staticRenderFns } from "./HistoryModalRequest.vue?vue&type=template&id=793960a8&scoped=true&"
import script from "./HistoryModalRequest.vue?vue&type=script&lang=js&"
export * from "./HistoryModalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793960a8",
  null
  
)

export default component.exports